import RecruitmentToWorkOnHolidaysContent from "./RecruitmentToWorkOnHolidaysContent";
import EmployeesListProvider from "./EmployeesListContext/EmployeesListProvider";

import ModalBanOverlay from "../../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";


const RecruitmentToWorkOnHolidaysModal = ({
                                              close, setStageModalWindow, testHOC, setSelectedE,
    selectedE,
}) => {

    return (


        <EmployeesListProvider>
            <RecruitmentToWorkOnHolidaysContent
                selectedE={selectedE}
                setSelectedE={setSelectedE}
                setStageModalWindow={setStageModalWindow}
                testHOC={testHOC}
                close={close} />
        </EmployeesListProvider>

    );
};

export default RecruitmentToWorkOnHolidaysModal;
